import { queryOptions } from "@tanstack/react-query";
import { WayflyerSchemas } from "api-types";
import { axiosClient } from "auth-sdk";

export const getFinancingStageQueryKey = (customerUuid: string | null | undefined) => ["financing-stage", customerUuid];
export const financingStageQueryOptions = (customerUuid: string | null | undefined) =>
  queryOptions({
    queryKey: getFinancingStageQueryKey(customerUuid),
    gcTime: 0,
    queryFn: () =>
      axiosClient.get<WayflyerSchemas.FinancingStageSchema>(`/api/wayflyer/company/${customerUuid}/financing-stage/`),
    select: ({ data }) => data,
    enabled: !!customerUuid,
  });

export const FinancingStagePath: Record<WayflyerSchemas.FinancingStage, string> = {
  remediation: "remediation",
  financing: "financing/advances",
  financing_dashboard: "financing",
  financing_funds_request_expired: "financing/funds-request/expired",
  financing_funds_request_offers: "financing/funds-request/offers",
  financing_funds_request_kyc: "financing/funds-request/kyc",
  financing_contract_order_form: "financing-contract-order-form",
  financing_funds_request_contracts_signed: "financing/funds-request/contracts/signed",
  financing_funds_request_contracts_review: "financing/funds-request/contracts/review",
  financing_funds_request_disqualified: "financing/funds-request/disqualified",
  funding_application: "funding/application",
  configure_new_funder_customer: "funding/application/configure-new-funder-customer",
} as const;
